import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  OrganizationalUnit,
  OrganizationalUnitsFilter,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  organizationalUnits: Identifiable<OrganizationalUnit>[];
  filter: OrganizationalUnitsFilter;
  totalPages: number;
  retrieveOrganizationalUnits(
    request: Boundaries["retrieveOrganizationalUnits"]["request"],
  ): void;
}

function useRetrieveOrganizationalUnits(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveOrganizationalUnitsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveOrganizationalUnitsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveOrganizationalUnitsRequestFailure,
    ),
    organizationalUnits: useSelector(selector.getOrganizationalUnits),
    filter: useSelector(selector.getOrganizationalUnitsFilter),
    totalPages: useSelector(selector.getOrganizationalUnitsTotalPages),
    retrieveOrganizationalUnits: core.retrieveOrganizationalUnits,
  };
}

export { useRetrieveOrganizationalUnits };
